import { useQuery } from '@tanstack/react-query';
import { useAuth } from '@/contexts/AuthContext';
import { getTokenFromStorage } from '@/utils/auth';
import { getClientCalendarSearch } from '@/api/beatlyApi';

/**
 * Calendar events for a date window (GET /app/v2/client/calendar/search).
 */
export function useClientCalendarSearch(dateFrom: string, dateTo: string) {
  const { user } = useAuth();
  const token = getTokenFromStorage();
  const enabled = Boolean(token && user?.is_client);

  return useQuery({
    queryKey: ['calendar', 'search', dateFrom, dateTo],
    enabled,
    staleTime: 60_000,
    queryFn: () =>
      getClientCalendarSearch(
        {
          dateFrom,
          dateTo,
          pageNumber: 0,
          pageSize: 100,
        },
        token ?? '',
      ),
  });
}
